export default __webpack_public_path__ + "static/media/O_Ovo.8afcd4bb.svg";